var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.707 1.293a1 1 0 00-1.414 0l-15 15a1 1 0 00-.274.51l-1 5a1 1 0 001.177 1.178l5-1a1 1 0 00.511-.274l15-15a1 1 0 000-1.414l-4-4zM18 8.586L20.586 6 18 3.414 15.414 6 18 8.586zm-4-1.172L16.586 10 6.507 20.079l-3.232.646.646-3.232L14 7.414z"
  })));
}
export default SvgEdit;